import type { WebsiteBlock } from '../../types'
import { useBranding } from '../../contexts/BrandingContext'
import { useI18n } from '../../i18n'

interface MenuProps {
  title: string
  titleEn?: string
  categories: Array<{
    name: string
    nameEn?: string
    items: Array<{
      name: string
      nameEn?: string
      description?: string
      descriptionEn?: string
      price: string
      imageUrl?: string
    }>
  }>
}

export default function MenuBlock({ block }: { block: WebsiteBlock }) {
  const { branding } = useBranding()
  const { lang } = useI18n()
  const p = block.props as MenuProps

  const title = lang === 'en' && p.titleEn ? p.titleEn : p.title
  const hasContent = title?.trim() || (p.categories && p.categories.length > 0)
  if (!hasContent) return null

  return (
    <section className="py-20 px-6 bg-gray-50/50">
      <div className="max-w-4xl mx-auto">
        {title?.trim() && (
          <h2 className="text-2xl md:text-3xl font-bold text-center mb-12 tracking-tight" style={{ color: branding.secondaryColor }}>
            {title}
          </h2>
        )}
        <div className="space-y-10">
          {(p.categories || []).map((cat, ci) => (
            <div key={ci}>
              <h3 className="text-lg font-semibold mb-4 pb-2 border-b" style={{ color: branding.primaryColor, borderColor: `${branding.primaryColor}30` }}>
                {lang === 'en' && cat.nameEn ? cat.nameEn : cat.name}
              </h3>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                {(cat.items || []).map((item, i) => (
                  <div key={i} className="flex gap-3 p-3 rounded-xl bg-white border border-black/[0.04]">
                    {item.imageUrl && (
                      <img src={item.imageUrl} alt="" className="w-16 h-16 rounded-lg object-cover shrink-0" />
                    )}
                    <div className="flex-1 min-w-0">
                      <div className="flex items-baseline justify-between gap-2">
                        <span className="text-sm font-medium truncate" style={{ color: branding.secondaryColor }}>
                          {lang === 'en' && item.nameEn ? item.nameEn : item.name}
                        </span>
                        <span className="text-sm font-bold shrink-0" style={{ color: branding.primaryColor }}>{item.price}</span>
                      </div>
                      {item.description && (
                        <p className="text-[11px] text-gray-400 mt-0.5 line-clamp-2">
                          {lang === 'en' && item.descriptionEn ? item.descriptionEn : item.description}
                        </p>
                      )}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}
